/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const TransactionsEnum = {
    PUT_TRANSACTION_START: '/transactions/start',
    PUT_TRANSACTION_COMMIT: '/transactions/commit',
    PUT_TRANSACTION_ROLLBACK: '/transactions/rollback'
};
